import { render } from "./ProjectMain.vue?vue&type=template&id=2d4a2520&scoped=true"
import script from "./ProjectMain.vue?vue&type=script&lang=js"
export * from "./ProjectMain.vue?vue&type=script&lang=js"

import "./ProjectMain.vue?vue&type=style&index=0&id=2d4a2520&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4a2520"]])

export default __exports__